import type { IAppState } from 'shared/common/state';

export const selectIsEtazhiBlackFridayEnabled = (state: IAppState) => {
  const isEnabled = !!state.config.get<boolean>('proApp.etazhiBlackFridayEnabled');

  return isEnabled;
};
